import * as React from 'react';
import { useState } from 'react';
import DateTime from 'react-datetime';
import { FormGroup, Checkbox } from 'react-bootstrap';
import { Translate } from '../../../../shared/LanguageService';
import ValidatableFormGroup from '../../../../components/common/ValidatableFormGroup';
import { ICreateOrderOther } from '../../Entities';
import moment from 'moment';

interface IProps {
    other: ICreateOrderOther;
    onChange: (selectedDate: any) => void;
    onDataChange: (e: any) => void;
    errors: any;
}

const CreateOrderSelectPreferredDateForm = (props: IProps) => {
    const [preferredDate, setPreferredDate] = useState(null);
    const [beforeNoonCheckboxChecked, setBeforeNoonCheckboxChecked] = useState(false);
    const [afternoonCheckboxChecked, setAfternoonCheckboxChecked] = useState(false);
    const [freeTimeCheckboxChecked, setFreeTimeCheckboxChecked] = useState(false);

    const onPreferredTimeOfPhotographingDateChange = (date: any) => {
        let value = date;
        if (date.target) {
            value = moment(date.target.value);
            setPreferredDate(value);
        }
        let preferredTimeOfPhotographing = value ? value.toDate() : null;
        props.onChange(preferredTimeOfPhotographing);
    }
    
    const onCheckboxChange = (e: any) => {
        setCheckedBox(e.target.value);
        let timeSlot = getTimeSlotFromValue(e.target.value);
        props.onDataChange({
            target: {
                name: 'other.preferredTimeOfPhotographingSlot',
                value: timeSlot
            }
        });
    }
    const getTimeSlotFromValue = (value: string) => {
        switch (value) {
            case '1':
                return Translate('orders/create/form/input-label/preferred-time-before-noon');
            case '2':
                return Translate('orders/create/form/input-label/preferred-time-afternoon');
            case '3':
                return Translate('orders/create/form/input-label/preferred-time-free-time');
            default:
                return '';
        }
    }
    
    const setCheckedBox = (value: string) => {
        switch (value) {
            case '1':
                if (beforeNoonCheckboxChecked) {
                    setBeforeNoonCheckboxChecked(false);
                    return;
                }
                setBeforeNoonCheckboxChecked(true);
                setAfternoonCheckboxChecked(false);
                setFreeTimeCheckboxChecked(false);
                break;
            case '2':
                if (afternoonCheckboxChecked) {
                    setAfternoonCheckboxChecked(false);
                    return;
                }
                setAfternoonCheckboxChecked(true);
                setFreeTimeCheckboxChecked(false);
                setBeforeNoonCheckboxChecked(false);
                break;
            case '3':
                if (freeTimeCheckboxChecked) {
                    setFreeTimeCheckboxChecked(false);
                    return;
                }
                setFreeTimeCheckboxChecked(true);
                setBeforeNoonCheckboxChecked(false);
                setAfternoonCheckboxChecked(false);
                break;
            default:
                break;
        }
    }
    
    
    return (
        <fieldset>
                <legend>
                    {Translate('orders/create/modal/preferred-time-of-photographing/title')}
                </legend>
            <div>
                <form>
                    <ValidatableFormGroup
                        validationKey="other.preferredDateTimePhotographing"
                        errors={props.errors}
                    >
                        <p>
                            {Translate(
                                'orders/create/modal/preferred-time-of-photographing/text-description'
                            )}
                        </p>
                        <DateTime
                            className="desktop-datetime"
                            locale={moment.locale()}
                            isValidDate={(current) => {
                                return current.isAfter(moment().add(-1, 'day'));
                            }}
                            value={preferredDate}
                            timeFormat={false}
                            onChange={onPreferredTimeOfPhotographingDateChange}
                            closeOnSelect={true}
                            inputProps={{
                                name: 'other.preferredDateTimePhotographing',
                                autoComplete: 'do-not-autocomplete',
                                placeholder: Translate(
                                    'orders/create/modal/preferred-time-of-photographing/preferred-time-placeholder-text')
                            }}
                        />
                    </ValidatableFormGroup>
                    <FormGroup>
                        <Checkbox
                            className="block"
                            name="other.preferredTimeOfPhotographingSlot"
                            checked={beforeNoonCheckboxChecked}
                            onChange={onCheckboxChange}
                            value={1}
                        >
                            <span>
                                {Translate(
                                    'orders/create/form/input-label/preferred-time-before-noon'
                                )}
                            </span>
                        </Checkbox>
                        <Checkbox
                            className="block"
                            name="other.preferredTimeOfPhotographingSlot"
                            checked={afternoonCheckboxChecked}
                            onChange={onCheckboxChange}
                            value={2}
                        >
                            <span>
                                {Translate(
                                    'orders/create/form/input-label/preferred-time-afternoon'
                                )}
                            </span>
                        </Checkbox>
                        <Checkbox
                            className="block"
                            name="other.preferredTimeOfPhotographingSlot"
                            checked={freeTimeCheckboxChecked}
                            onChange={onCheckboxChange}
                            value={3}
                        >
                            
                            <span>
                                {Translate(
                                    'orders/create/form/input-label/preferred-time-free-time'
                                )}
                            </span>
                        </Checkbox>
                    </FormGroup>
                </form>
            </div>
        </fieldset>
    );
}

export default CreateOrderSelectPreferredDateForm;
